import React from 'react';
//import './styles/DesignerStyles.css';

import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';

import DesignerButton from './DesignerButton';
import CupIconSvgComponent from './CupIconSvgComponent';

import { checkForCode, getRoomId, androidBackButton } from './Utils';

class RoundCompleted extends React.Component {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  };

  constructor(props) {
    super(props);

    // eslint-disable-next-line
    const { cookies } = props;

    this.state = {
      sub: '',

      room: {},

      winningTeamColor: '#078BEB',
      timeoutID: 0,
    };
  }

  onPause = () => {
    console.log("App paused");
    if (this.state.timeoutID) {
      clearTimeout(this.state.timeoutID);
    }
  }

  onResume = () => {
    console.log("App resumed");
    if (this.state.room && this.state.room._id) {
       console.log("Forcing immediate loadPage on resume");
       if (this.state.timeoutID) clearTimeout(this.state.timeoutID);
       this.loadPage(); 
    } else {
       console.log("Resumed but no room ID yet.");
    }
 }

  componentDidMount() {
    androidBackButton(this.handleStatisticsButton);

    let code = this.props.cookies.get('code');

    this.setState({ sub: code }, () => {
      this.loadPage();
    });
    document.addEventListener('pause', this.onPause, false);
    document.addEventListener('resume', this.onResume, false);
  }

  componentWillUnmount() {
    document.removeEventListener('pause', this.onPause, false);
    document.removeEventListener('resume', this.onResume, false);
  }

  loadPage = async () => {
    let data = await checkForCode(
      'GET',
      `/api/rooms/${getRoomId()}`,
      this.props,
      null
    );

    data.teams.sort((a, b) => {
      return b.points - a.points;
    });

    if (this.state.room.startNextRound && this.state.room.currentTeam !== -1) {
      this.props.navigate(`/game/${getRoomId()}`);
    }

    this.setState({ room: data });
  };

  handleStartNextRound = () => {
    let body = JSON.stringify({
      startNextRound: true,
    });

    checkForCode(
      'PUT',
      `/api/rooms/${getRoomId()}/startNextRound`,
      this.props,
      body
    );
  };

  handleStatisticsButton = () => {
    this.props.navigate(`/Info/${getRoomId()}`);
  };
  handleStartNextGame = () => {
    this.props.navigate(`/`);
  };

  render() {
    clearTimeout(this.state.timeoutID);
    if (this.state.room._id) {
      // eslint-disable-next-line
      this.state.timeoutID = setTimeout(() => {
        this.loadPage();
      }, 1000);
    }

    return (
      <div className="Home">
        <div className="arrowBackButtonDiv_CG">
          <DesignerButton
            class="arrowBackButton refresh"
            onClick={() => {window.location.reload();}}></DesignerButton>
        </div>
        <div className="arrowBackButtonDiv_CG QR">
          <DesignerButton
            class="arrowBackButton"
            onClick={() => {this.props.navigate(`/QRCodePage/${getRoomId()}`);}}></DesignerButton>
        </div>
        {this.state.room.currentRound === -1 ? (
          <>
            <h1 className="rankingHeader">Играта приключи</h1>
            <CupIconSvgComponent teamName={this.state.room.teams[0].teamName} />
            <h4>{this.state.room.teams[0].displayName} Won!</h4>
          </>
        ) : this.state.room.teams ? (
          <div className="RoundAndRankingParagraphHolder">
            <h1 className="rankingHeader">
              Край на рунд {this.state.room.currentRound - 1}
            </h1>
            <p>Класация</p>
          </div>
        ) : (
          <></>
        )}

        {this.state.room.teams ? (
          this.state.room.teams.map((element, index) => (
            <div key={index} className="teamsMapOuterDiv">
              <div className={`teamNameHolder ${element.teamName}`}>
                {element.displayName}
              </div>

              <div
                className={
                  index === 0 && this.state.room.currentRound === -1
                    ? `teamHolder ${element.teamName}Winner`
                    : `teamHolder ${element.teamName}`
                }>
                <div className="RankingCircle">{index + 1}</div>
                {element.teamPlayers.map((player) => {
                  return (
                    <div className="playerCircleIcon" key={player.sub}>
                      <div
                        className="img"
                        style={{
                          backgroundImage: `url('${
                            window.viewType === 'phone'
                              ? `${process.env.REACT_APP_MOBILE_BACKEND_URL}`
                              : ''
                          }/api/${player.sub}/user-picture')`,
                        }}></div>
                    </div>
                  );
                })}

                <div className="teamPointsP">{element.points} т.</div>
              </div>
            </div>
          ))
        ) : (
          <></>
        )}

        {this.state.room.currentRound === -1 ? (
          <>
            {/* <DesignerButton
              style={{ position: 'absolute', right: '20px', top: '75px' }}
              class="statisticsButton"
              onClick={this.handleStatisticsButton}></DesignerButton> */}

            <div className="ButtonHolder">
              <DesignerButton
                class="filledButton"
                onClick={this.handleStartNextGame}
                buttonText="Започни нова игра"></DesignerButton>
            </div>
          </>
        ) : (
          <></>
        )}

        {this.state.room.owner ? (
          this.state.room.owner === this.state.sub &&
          this.state.room.currentRound !== -1 ? (
            <div
              className="ButtonHolder"
              style={{ paddingTop: '40px', marginTop: '40px' }}>
              <DesignerButton
                class="filledButton"
                onClick={this.handleStartNextRound}
                buttonText="Започни следващ рунд"></DesignerButton>
            </div>
          ) : (
            <></>
          )
        ) : (
          <></>
        )}
      </div>
    );
  }
}

export default withCookies(RoundCompleted);
